import Cookies from 'js-cookie';

class CookieBar {
  constructor(options = {}) {
    this.config = {
      expireDays: 365,
      cookiePath: '/',
      module: document.querySelector('[data-module="CookieBar"]'),
      ...options
    };
  }

  init() {
    const { module, expireDays, cookiePath } = this.config;

    if (!this.config.module) {
      return;
    }

    const button = module.querySelector('[type="submit"]');

    if (!button) {
      return;
    }

    button.addEventListener('click', e => {
      const approvedCookies = Array.from(
        module.querySelectorAll('input[type="checkbox"]:checked')
      ).map(checkbox => checkbox.getAttribute('name'));

      e.preventDefault();

      if (approvedCookies.length) {
        const isHttps = window.location.protocol === 'https:';
        Cookies.set('png_approvedCookies', approvedCookies.join(','), {
          expires: expireDays,
          path: cookiePath,
          sameSite: isHttps ? 'none' : '',
          secure: isHttps
        });
      }
      window.dataLayer.push({ event: 'cookie_consent_given', data: approvedCookies });
      if (module) {
        module.remove();
      }
    });
  }
}

export default CookieBar;
